export const FRAUD_NET_NO_SCRIPT_TEST_ID = 'fraud-net-no-script'
